import { gql, useMutation } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const removeAccountantRefereeMutation = gql`
  mutation removeAccountantReferee(
    $customerId: String!
    $subjectId: String!
    $userId: String!
    $reason: String!
    $refereeId: String
  ) {
    removeAccountantReferee(
      customerId: $customerId
      subjectId: $subjectId
      userId: $userId
      reason: $reason
      refereeId: $refereeId
    )
  }
`

export type MutationVars = {
  customerId: string
  subjectId: string
  userId: string
  reason: string
  refereeId: string
}

export type RemoveAccountantRefereeData = {
  removeAccountantReferee: string | unknown
}

export const useRemoveAccountantRefereeMutation: WrappedMutation<
  RemoveAccountantRefereeData,
  MutationVars
> = () =>
  useMutation<RemoveAccountantRefereeData, MutationVars>(
    removeAccountantRefereeMutation,
    {
      client: agentClient,
    },
  )
